module.exports = __webpack_public_path__ + "static/media/6_export.e26e5b34.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/6_export.mp4
// module id = 321
// module chunks = 0